import { menu_tree_get } from 'server/modules/351.js'
import { menuPonds1, menuPonds2 } from 'utils/dictionary.js'

import { _getQueryString } from 'cupshe-utils'
let items = []
let uweb = []
let menusByPath = {}
let obj = {
  systemId: '',
  menuName: '',
  openKeys: [],
  selectedKeys: []
}
let systemId = '',
  systemName = ''
const getUweb = () => {}
const deepItem = childrens => {
  childrens.forEach(element => {
    const { menuPath, menuName, id, parentId } = element
    if (parentId === 0) {
      obj = {
        systemId: id,
        menuName: '',
        openKeys: [],
        selectedKeys: []
      }
      systemId = id
      systemName = menuName
    }
    items.push(
      Object.assign(element, {
        systemId,
        systemName
      })
    )

    if (element.childrenList) {
      deepItem(element.childrenList)
    } else {
      obj.menuPath = menuPath
      obj.menuName = menuName
      obj.selectedKeys = [menuPath]
      menusByPath[menuPath] = Object.assign({}, obj)
    }
  })
}

export default {
  namespaced: true,
  state: {
    // 权限菜单
    menus: [],

    userInfo: {
      jobNumber: '',
      email: '',
      // 登陆人的信息
      userId: '',
      userName: '',
      token: null,
      avatar: null,
      dingTalkUserId: null
    },
    menuList: [],
    routerTags: [],
    tagsMax: 20,
    menusByPath: {}
  },
  mutations: {
    updateMenus(state, data) {
      // 变更状态
      const index = data.findIndex(item => item.menuName === '统一网站')
      if (index === -1) {
        state.menus = data || []
      } else {
        const item = data.splice(index, 1)[0]
        state.menus = [...item.childrenList, ...data]
      }
    },
    updateMenuList(state, data) {
      deepItem(data)
      // 变更状态
      state.menuList = items || []
      state.menusByPath = menusByPath
    },
    updateTags(state, tags) {
      state.routerTags = tags
      sessionStorage.setItem('routerTags', JSON.stringify(state.routerTags))
    },
    /**
     * 设置路由的历史记录
     * @param {*} state
     * @param {*} data
     * @param {*} operateType  null 添加   1 删除  2 清空
     */
    saveHistoryRouter(state, item) {
      const onDelete = index => {
        const deleteItem = state.routerTags[index]
        state.routerTags.splice(index, 1)
        document.getElementById(deleteItem.menuPath) &&
          document.getElementById(deleteItem.menuPath).remove()
        // tagDom && tagDom.click()
      }
      const data = item.data
      if (data) {
        data['systemId'] =
          data.systemId || localStorage.getItem('otherSystemId')
      }
      const tagDom =
        data && data.menuPath
          ? document.querySelector(`[data-path='${data.menuPath}']`)
          : null
      const sessionTags = sessionStorage.getItem('routerTags')
      state.routerTags = (sessionTags && JSON.parse(sessionTags)) || []
      // 子页面传递路由
      if (data && data.type === 'breadcrumb') {
        const index = state.routerTags.findIndex(tag => {
          return tag.menuPath === data.menuPath
        })

        if (index > -1) {
          if (data.isDelete) {
            onDelete(index)
          } else if (
            // 存在相同子详情页，不同入参页面
            data.basePath === state.routerTags[index].basePath &&
            data.menuName !== state.routerTags[index].menuName
          ) {
            state.routerTags.push(data)
          } else {
            state.routerTags.splice(index, 1, data)
            tagDom && tagDom.click() // 解决详情页再次点击无法跳转的bug
          }
        } else {
          state.routerTags.push(data)
        }
        if (state.routerTags.length > state.tagsMax) {
          state.routerTags.shift()
        }
      } else {
        if (data && data.menuPath === '/') {
          return false
        }
        if (item.index === -1) {
          state.routerTags = []
        } else if (item.index > -1) {
          onDelete(item.index)
          // const deleteItem = state.routerTags[item.index]
          // state.routerTags.splice(item.index, 1)
          // document.getElementById(deleteItem.menuPath) &&
          //   document.getElementById(deleteItem.menuPath).remove()
        } else if (data) {
          let deleteIndex = -1
          for (let i = 0; i < state.routerTags.length; i++) {
            if (state.routerTags[i].menuPath === data.menuPath) {
              deleteIndex = i
            }
          }
          if (deleteIndex === -1) {
            state.routerTags.push(item.data)
          } else {
            state.routerTags[deleteIndex].systemId = data.systemId
            const tagDom = document.querySelector(
              `[data-path='${data.menuPath}']`
            )
            tagDom && tagDom.click()
          }
          // 如果是点击左侧菜单需重新打开页面，如果是点击的菜单即是当前页面，不做任何处理
          const target =
            location.href.split('target=').length === 2
              ? decodeURIComponent(location.href.split('target=')[1])
              : location.pathname
          if (item.isMenu && deleteIndex > -1 && data.menuPath !== target) {
            state.routerTags.splice(deleteIndex, 1)
            document.getElementById(data.menuPath) &&
              document.getElementById(data.menuPath).remove()
            state.routerTags.push(item.data)
          }

          if (state.routerTags.length > state.tagsMax) {
            state.routerTags.shift()
          }
        }
      }
      sessionStorage.setItem('routerTags', JSON.stringify(state.routerTags))
    },
    // 维护用户登录信息
    saveUserInfo(state, obj) {
      const { id, name, token, email, jobNumber, avatar, dingTalkUserId } = obj
      state.userInfo = {
        userId: id,
        userName: name,
        token: token,
        email: email,
        jobNumber: jobNumber,
        avatar,
        dingTalkUserId
      }
      localStorage.setItem('token', token)
    },
    SET_RESETSTATE(state) {
      Object.assign(state, {
        userInfo: {},
        // 权限菜单
        menus: [],
        menuList: [],
        routerTags: [],
        tagsMax: 20
      })
    }
  },
  actions: {
    // actions一般是处理异步逻辑
    async GetMenusAction({ commit }) {
      const result = await menu_tree_get().catch(e => {
        console.log(e)
      })
      if (result && result.success) {
        const {
          data: { list }
        } = result
        let dataList = []
        const index = list.findIndex(item => {
          return item.menuName === '统一网站'
        })
        if (index === -1 || list[index].childrenList.length === 0) {
          dataList.push({
            menuName: '首页',
            menuNameEn: 'Home',
            menuPath: '/home',
            menuType: 2,
            parentId: 0
          })
        }
        commit('updateMenuList', [...dataList, ...list])
        commit('updateMenus', [...dataList, ...list])
      }
    }
  }
}
